export const NAMESPACE = {
  AUTH: "auth",
  APP: "app",
};

// Types of container type for widgets
export const LOGIN_ERROR = {
  ACCESS_CODE_NOT_ALLOWED: "security.login.account.not.allowed.access.code.login",
  ACCESS_DENIED: "security.access.denied",
  ACCOUNT_DISABLED: "security.account.disabled",
  ACCOUNT_LOCKED: "security.login.credentials.account.locked",
  ACCOUNT_MANAGER_LOCKED: "security.login.credentials.account.manager.locked",
  ACCOUNT_NOT_ACTIVATED: "security.account.not.activated",
  ALP_ADMIN_LOCKED: "security.login.credentials.alptemplate.admin.locked",
  APP_ADMIN_LOCKED: "security.login.credentials.app.admin.locked",
  AUTHORITY_ADMIN_LOCKED: "security.login.credentials.authority.admin.locked",
  CCPM_ADMIN_LOCKED: "security.login.credentials.ccpm.admin.locked",
  CO_CA_LOCKED: "security.login.credentials.co.and.ca.locked",
  CREDENTIALS_LOCKED: "security.login.credentials.locked",
  DEFAULT_LOCKED: "security.login.credentials.default.locked",
  HELPDESK_ADMIN_LOCKED: "security.login.credentials.helpdesk.admin.locked",
  INCORRECT_CREDENTIAL: "security.login.credentials.incorrect",
  SCHOOL_ADMIN_LOCKED: "security.login.credentials.school.admin.locked",
  STUDENT_ACCOUNT_LOCKED: "security.login.credentials.student.locked",
  STUDENT_SOFT_SUSPENDED: "security.login.credentials.student.soft.suspended",
  TEACHER_ACCOUNT_LOCKED: "security.login.credentials.teacher.locked",
  VLE_ADMIN_LOCKED: "security.login.credentials.vle.admin.locked",
};

export const RESET_PASSWORD_ERROR = {
  USERNAME_EMPTY: "reset.password.username.empty",
};

export const LOGIN_FLOW_TYPE = {
  E_ASSESSMENT: "E_ASSESSMENT",
};
